export const conceptTypes = [
  { label: "Capacitación a personal", value: "PERSONAL_TRAINING" },
  { label: "Capacitación a beneficiario", value: "BENEFICIARY_TRAINING" },
  { label: "Equipamiento", value: "EQUIPMENT" },
  { label: "Eventos", value: "EVENTS" },
  { label: "Gastos administrativos", value: "ADMINISTRATIVE_EXPENSES" },
  { label: "Gastos de viaje", value: "TRAVEL_EXPENSES" },
  { label: "Gastos financieros", value: "FINANCIAL_EXPENSES" },
  { label: "Mantenimiento", value: "MAINTENANCE" },
  { label: "Materiales y suministros", value: "SUPPLIES" },
  { label: "Promoción y publicidad", value: "MARKETING" },
  { label: "Recurso humano", value: "HUMAN_RESOURCE" },
  { label: "RH Gasto administrativo", value: "ADMINISTRATIVE_HUMAN_RESOURCE" },
  { label: "RH Promoción y publicidad", value: "ADVERTISEMENT_HUMAN_RESOURCE" },
  { label: "Seguimiento y evaluación", value: "MONITORING" }
]